export const imageMapArea = [
	{
		title: 'California',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">27,363+ </span>  Marketplaces in <span style="font-weight: 800; color: #636161;">USA</span>',
		coords: '111,104,142,149',
		shape: 'rect',
		content:
			'Based in <span style="font-weight: 800; color: #636161;">California.</span>, <span style="color: #00aeff;">Bootstrap</span>, a popular front-end-framework uses Dokan for their Multi Vendor Theme Marketplace.',
		location: '',
		country: 'US',
		flag: 'us',
		link: '',
	},
	{
		title: 'Canada',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">328+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Canada</span>',
		coords: '299,39,322,70',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Fresh wagon</span> offers locally sourced fruit, vegetable, meat and other daily needed products all across <span style="font-weight: 800; color: #636161;">Canada</span>.',
		location: 'Canada',
		country: 'Canada',
		flag: 'canada',
		link: '',
	},
	{
		title: 'San',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">27,363+</span>  Marketplaces in <span style="font-weight: 800; color: #636161;">USA</span>',
		coords: '162,157,191,200',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">With the Wilcity</span> app of <span style="font-weight: 800; color: #636161;">San Francisco</span>, people can explore popular malls, spas, cafes etc categorically worldwide.',
		location: '',
		country: '',
		flag: 'us',
		link: '',
	},
	{
		title: 'Michigan',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">27,363+</span>  Marketplaces in <span style="font-weight: 800; color: #636161;">USA</span>',
		coords: '303,156,323,185',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Forstep Style</span> is operating a progressive online fashion products marketplace in Houghton, <span style="font-weight: 800; color: #636161;">Michigan</span>.',
		location: 'Michigan',
		country: 'US',
		flag: 'us',
		link: '',
	},
	{
		title: 'Ecuador',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">2,200+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Latin America</span>',
		coords: '268,306,291,338',
		shape: 'rect',
		content:
			'Founded in <span style="font-weight: 800; color: #636161;">Quito and Valles</span>, <span style="color: #00aeff;">Día Eventos</span>, is an event management company that provides a comprehensive service.',
		location: 'Ecuador',
		country: 'Ecuador',
		flag: 'ecuador',
		link: '',
	},
	{
		title: 'Brazil',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">1,170+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Brazil</span>',
		coords: '364,380,387,411',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">3F MAX</span> is an online retailer providing locally sourced products to customers\' doorsteps on demand.',
		location: 'Brazil',
		country: 'Brazil',
		flag: 'brazil',
		link: '',
	},
	{
		title: 'Florida',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">27,363+</span>  Marketplaces in <span style="font-weight: 800; color: #636161;">USA</span>',
		coords: '379,106,391,123',
		shape: 'rect',
		content:
			'<span style="font-weight: 800; color: #636161;">Florida</span> based <span style="color: #00aeff;">Gear Source</span> is a unique marketplace where buyers and customers can connect and communicate.',
		location: 'Florida',
		country: 'US',
		flag: 'us',
		link: '',
	},
	{
		title: 'Germany',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">442+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Germany</span>',
		coords: '561,60,530,15',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Imkerwelt24</span> offers a range of products for beekeeping, cutaring from small scale to regional standard size all over <span style="font-weight: 800; color: #636161;">Germany</span>.',
		location: 'Germany',
		country: 'Germany',
		flag: 'germany',
		link: '',
	},
	{
		title: 'Ireland',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">50+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Ireland</span>',
		coords: '534,102,548,120',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Shop in Ireland</span> is proudly the largest marketplace to host 1000+ Irish designers, crafters & small businesses.',
		location: 'Ireland',
		country: 'Ireland',
		flag: 'ireland',
		link: '',
	},
	{
		title: 'France',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">594+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">France</span>',
		coords: '546,200,561,221',
		shape: 'rect',
		content:
			'Assisting local <span style="font-weight: 800; color: #636161;">French</span> enterprises, <span style="color: #00aeff;">Achat en Val de Sully</span>, smoothens the ecommerce digitization process.',
		location: 'France',
		country: 'France',
		flag: 'france',
		link: '',
	},
	{
		title: 'UK, London',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">1450+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">England</span>',
		coords: '616,83,597,113',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Coveti</span>, in <span style="font-weight: 800; color: #636161;">Greater London</span>, assembles global fashion designers on their site to facilitate direct purchases.',
		location: 'Greater London',
		country: 'England',
		flag: 'uk',
		link: '',
	},
	{
		title: 'UK, Reading GB',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">1450+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">England</span>',
		coords: '627,93,647,122',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Hawk and Peddle</span> an online marketplace of <span style="font-weight: 800; color: #636161;">Reading, GB</span>, provides an exclusive product vendor monopoly platform.',
		location: 'England',
		country: 'England',
		flag: 'uk',
		link: '',
	},
	{
		title: 'Austria',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">60+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Austria</span>',
		coords: '597,199,612,176',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Joshi</span> is an <span style="font-weight: 800; color: #636161;">Austrian</span> marketplace where providers can directly sell nutritious and healthy foods to customers.',
		location: 'Austria',
		country: 'Austria',
		flag: 'austria',
		link: '',
	},
	{
		title: 'S.Africa',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">424+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">South Africa</span>',
		coords: '598,235,614,256',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Bakgat Books</span> facilitates the trade of books through a secure and trustworthy online portal.',
		location: 'S.Africa',
		country: 'S.Africa',
		flag: 'southAfrica',
		link: '',
	},
	{
		title: 'Saudi Arabia',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">5100+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Middle East</span>',
		coords: '662,312,693,265',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Baity</span> provides <span style="font-weight: 800; color: #636161;">Saudi</span> customers with interior & exterior designing accessories as well as accredited designers.',
		location: '',
		country: '',
		flag: 'saudiArabia',
		link: '',
	},
	{
		title: 'Iran',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">4,692+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Iran</span>',
		coords: '692,163,721,207',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Graphic 30T</span> is an <span style="font-weight: 800; color: #636161;">Iranian</span> graphics designing firm working to provide aesthetic print and digital designs.',
		location: 'Iran',
		country: 'Iran',
		flag: 'iran',
		link: '',
	},
	{
		title: 'India',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">1702+</span>  Marketplaces in <span style="font-weight: 800; color: #636161;">India</span>',
		coords: '808,149,786,182',
		shape: 'rect',
		content:
			'Located in <span style="font-weight: 800; color: #636161;">Ahmednagar, Maharashtra</span>, <span style="color: #00aeff;">FotoVilla</span> is popular for their unique & customizable quality products.',
		location: 'India',
		country: 'India',
		flag: 'india',
		link: '',
	},
	{
		title: 'China',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">50+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">China</span>',
		coords: '904,152,874,107',
		shape: 'rect',
		content:
			'Manufacturers, Exporters and importers are connected globally by <span style="color: #00aeff;">CharNO4.com</span> of <span style="font-weight: 800; color: #636161;">China</span>, a massive B2B marketplace.',
		location: 'China',
		country: 'China',
		flag: 'china',
		link: '',
	},
	{
		title: 'Russia',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">468+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Russia</span>',
		coords: '996,98,964,52',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Sadovod</span>, a marketplace in <span style="font-weight: 800; color: #636161;">Moscow</span>, operates in the unique niche of being a wholesaler as well as retail store.',
		location: 'Russia',
		country: 'Russia',
		flag: 'russia',
		link: '',
	},
	{
		title: 'Malaysia',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">207+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Malaysia<s/trong>',
		coords: '995,295,1010,273',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">JENAMA LOKAL</span> is a local ecommerce hub in <span style="font-weight: 800; color: #636161;">Malaysia</span> ensuring a safe payment platform with fast delivery.',
		location: 'Malaysia',
		country: 'Malaysia',
		flag: 'malaysia',
		link: '',
	},
	{
		title: 'S.Korea',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">39+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">South Korea</span>',
		coords: '1100,266,1123,229',
		shape: 'rect',
		content:
			'In providing the daily needs of customer items, <span style="color: #00aeff;">ireview</span> is a very popular online marketplace in <span style="font-weight: 800; color: #636161;">South Korea</span>.',
		location: 'S.Korea',
		country: 'S.Korea',
		flag: 'southKorea',
		link: '',
	},
	{
		title: 'Japan',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">43+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Japan<s/trong>',
		coords: '1223,226,1198,264',
		shape: 'rect',
		content:
			'Japanese online store <span style="color: #00aeff;">icuteJP</span> is a pioneer store offering a range of consumer products ensuring shopping ease.',
		location: 'Japan',
		country: 'Japan',
		flag: 'japan',
		link: '',
	},
	{
		title: 'Australia, Brisbane',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">430+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Australia</span>',
		coords: '1200,366,1176,402',
		shape: 'rect',
		content:
			'The only online baby shop, <span style="color: #00aeff;">Little Kids Business</span>, is the comfort solution for busy <span style="font-weight: 800; color: #636161;">Australian</span> parents to shop.',
		location: 'Australia',
		country: 'Australia',
		flag: 'australia',
		link: '',
	},
	{
		title: 'Australia, Surfers Paradise',
		heading:
			'<span style="font-weight: 800; color: #636161; display: block;">430+</span> Marketplaces in <span style="font-weight: 800; color: #636161;">Australia</span>',
		coords: '1219,436,1244,471',
		shape: 'rect',
		content:
			'<span style="color: #00aeff;">Aussie Mega Mall</span> is a one-stop shop providing a wide range of customer products and hosts over 34000+ vendors.',
		location: 'Australia',
		country: 'Australia',
		flag: 'australia',
		link: '',
	},
];
